import { useEffect } from 'react'
import { SetUser } from '../../Actions/UserA'
import { useDispatch, useSelector } from 'react-redux'
import { GetLocalStorage } from '../LocalStorage/LocalStorage'
import { useNavigate, useLocation } from 'react-router-dom'
import { GeneralEvent } from '../../Actions/Events/FilterA'

const useCheckLogin = (Navigation, UserType, InstituteUserTypes) => {
    const Navigate = useNavigate()
    const location = useLocation()
    const Dispatch = useDispatch();
    const { Authenticated } = useSelector((Store) => Store.LoginSignupReducer);
    let Institute = CheckInstitute(InstituteUserTypes, UserType)
    let User = CheckUser(UserType)
    let AllowNotLogin = CheckAllowNotLogin(UserType)
    
    // Check if this is an admin enrollment (admin enrolling a learner)
    const isAdminEnrollment = sessionStorage.getItem("isAdminEnrollment") === "true" || 
                               location.state?.isAdminEnrollment === true
    
    // console.log('GetLocalStorage("UserInfo")', GetLocalStorage("UserInfo"))
    useEffect(() => {
        // Skip all checks if this is an admin enrollment
        if (isAdminEnrollment) {
            return
        }

        if (GetLocalStorage("UserInfo")) {
            Dispatch(SetUser(GetLocalStorage("UserInfo")))

            if (UserType.length > 0) {
                if (GetLocalStorage("UserInfo")?.User === User) {
                    if (GetLocalStorage("UserInfo")?.User === "Institute" && !Institute)
                        Navigate('/')
                }
                else if (GetLocalStorage("UserInfo")?.User !== User)
                    Navigate('/')
            }
        }
        else if (!GetLocalStorage("UserInfo") && AllowNotLogin) {
            return
        } 

    else if (!Authenticated || !GetLocalStorage("UserInfo")) {
            if (Navigation)
                Navigate('/')
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Dispatch, Navigate, Navigation, Institute, Authenticated, isAdminEnrollment])

}


function CheckInstitute(InstituteUserTypes, UserType) {
    let checkInstitute = false;
    let UserTypeName
    UserType.forEach((UserName) => {
        if (UserName === "Institute")
            UserTypeName = UserName
    })

    if (UserTypeName === "Institute")
        InstituteUserTypes?.forEach(InstituteUserTypeName => {
            if (GetLocalStorage("UserInfo")?.InstituteUserType === InstituteUserTypeName) checkInstitute = true
        });
    else return true


    return checkInstitute
}

function CheckUser(UserTypes) {
    let checkUser
    UserTypes?.forEach(UserTypeName => {
        if (GetLocalStorage("UserInfo")?.User === UserTypeName) checkUser = UserTypeName
    });

    return checkUser
}


// function CheckInstructor(UserTypes) {
//     let checkUser
//     UserTypes?.forEach(UserTypeName => {
//         if (GetLocalStorage("UserInfo")?.User === UserTypeName) checkUser = UserTypeName
//     });

//     return checkUser
// }

function CheckAllowNotLogin(UserTypes) {
    let checkUser
    UserTypes?.forEach(UserTypeName => {
        if (UserTypeName === "User") checkUser = true
    });

    return checkUser
}


export const useSetLoginInfo = () => {

    const Dispatch = useDispatch();
    const { Authenticated } = useSelector((Store) => Store.LoginSignupReducer);
    useEffect(() => {
        if (GetLocalStorage("UserInfo")) {
            Dispatch(SetUser(GetLocalStorage("UserInfo")))
            Dispatch(GeneralEvent(GetLocalStorage("UserInfo").Notifications, "GetNotificationsSuccess"))
        }
    }, [Dispatch])
}
export default useCheckLogin